import type { EffectiveRole } from '@/lib/types';

/**
 * الصفحة الأولى بعد الدخول بحسب الدور — مصدرٌ واحد (25 سبتمبر 2026).
 *
 * كانت مكتوبةً داخل `HomeRedirect` وحده؛ ثم احتاجها شريطُ التبويب السفلي على الجوال
 * ليعرف متى يكون تبويبُ «الرئيسية» هو الحالي. نسختان تفترقان عند أول تعديل، فصارت دالّةً
 * يقرؤها الاثنان.
 */
export function homePathFor(roles: readonly EffectiveRole[]): string {
  // إدارةُ المنصة وأقسامُها (0066): لوحةُ اليوم بأرقام ما يخصّ كلَّ صفة
  if (roles.some((r) => r.startsWith('PLATFORM_'))) return '/platform';
  // المشرف الرقابي حسابٌ مستقل بلا عضوية ولا صفة أخرى — سطحه /oversight وحده
  if (roles.includes('REGULATORY_SUPERVISOR')) return '/oversight';
  // الطالب (بوابة التمارين أو الإرشاد) يصل إلى صفحته المرحّبة لا إلى لوحة الكبار
  if (roles.includes('STUDENT')) return '/me/student';
  if (roles.some((r) => ['INSTITUTION_ADMIN', 'INTERNAL_SUPERVISOR', 'SPECIALIST', 'COUNSELOR'].includes(r))) return '/app';
  if (roles.includes('TEACHER')) return '/me/class';
  // الموظفُ الإداري (0078) عملُه الرسائل
  if (roles.includes('OFFICE_STAFF')) return '/app/messages';
  if (roles.includes('PARENT')) return '/me/children';
  if (roles.includes('CLIENT')) return '/services';
  if (roles.includes('PROFESSIONAL')) return '/me/professional';
  return '/no-context';
}
